import React, { useState } from 'react';
import { useQuery } from 'react-query';
import classNames from 'classnames/bind';
import styles from './assets/styles.scss';
import apiClient from '../../../helpers/apiClient';
import RaceDetails from './RaceDetails';
import Loader from '../../Loader2/Loader';

const cx = classNames.bind(styles);

async function getSettings() {
  return (await apiClient().get('/v1/leaderboard/setting')).data;
}

export default function Races() {
  const [currentType, setCurrentType] = useState('weekly');
  const { data: settings = {}, isLoading } = useQuery(['settings', 'races'], () => getSettings(), {
    refetchOnWindowFocus: true,
  });

  function toggleOpen(raceType) {
    if (raceType === currentType) {
      setCurrentType(raceType === 'weekly' ? 'daily' : 'weekly');
    } else {
      setCurrentType(raceType);
    }
  }

  let raceComponents;

  if (!isLoading) {
    raceComponents = ['weekly', 'daily'].map(raceType => (
      <RaceDetails
        raceType={raceType}
        settings={settings?.curr[raceType]}
        isOpen={currentType === raceType}
        toggleOpen={() => toggleOpen(raceType)}
      />
    ));
  } else {
    raceComponents = <Loader />;
  }

  return <div className={cx('race-table-container')}>{raceComponents}</div>;
}
